import React from "react";
import "./style.scss";

const Counter = (props) => {
  const renderElement = (count) => {
    let i;
    let elements = [];
    for (i = 0; i < 7; i++) {
      if (i < count)
        elements[i] = <div key={i} className="counter-active"></div>;
      else elements[i] = <div key={i} className="counter-inactive"></div>;
    }
    return elements;
  };

  return (
    <div
      className="counter"
      style={
        props.breath
          ? { opacity: 0.1 }
          : { opacity: 1, transition: " opacity 800ms ease-in-out" }
      }
    >
      {renderElement(props.selectedCount)}
    </div>
  );
};

export default Counter;
